import {
  configureDataGaugeCommon,
  printNoDataChart,
  printDataChart,
  initChart,
  addPointInteger,
} from 'vlcishared';
import { formatRoundTooltip } from '../common-chart';

export const defaultOptions = {
  color: undefined,
  title: {
    text: '',
    left: 'center',
    top: 'top',
    padding: 10,
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 600,
      color: '#666',
    },
  },
  tooltip: {
    show: true,
    textStyle: {
      fontFamily: 'Montserrat',
    },
  },
  splitNumber: 3,
  series: {
    type: 'gauge',
    max: undefined,
    startAngle: -180,
    endAngle: 0,
    splitNumber: 2,
    pointer: {
      show: false,
      icon: 'roundRect',
    },
    progress: {
      show: true,
      overlap: false,
      roundCap: true,
      clip: true,
      itemStyle: {
        borderWidth: 1,
        borderColor: '#464646',
      },
    },
    axisLine: {
      lineStyle: {
        width: 60,
      },
    },
    splitLine: {
      show: true,
      distance: 10,
      length: 10,
    },
    axisTick: {
      show: true,
      splitNumber: 10,
    },
    axisLabel: {
      show: true,
      distance: 70,
      formatter: undefined,
      fontFamily: 'Montserrat',
      color: '#666',
    },
    data: [],
    detail: {
      fontSize: 12,
      color: 'inherit',
    },
  },
  toolbox: {
    show: true,
    feature: {
      saveAsImage: { title: 'Desar' },
    },
    right: 27,
    top: 30,
  },
};

/**
 * Función que se ha creado con el objetivo de ejecutar codigo en común para pintar
 * gauges anuales
 * @param {Object} gaugeYearConfig Objeto que contiene la configuración individual del gauge.
 * El objeto debe contener:
 * {Text} idChart: Identificador del chart en el html.
 * {Text} idNoData: Identificador de la pantalla de sin datos en el html.
 * {Text} chartName: Nombre del grafico.
 * {Number} fontSize: Tamaño del texto de las series.
 * {Number} paramOffsetCenterTitle: Porcentaje de la ubicacion vertical
 * del titulo de las series.
 * {Number} paramOffsetCenterDetail: Porcentaje de la ubicacion vertical
 * del valor de las series.
 * {Number} paramOffsetLabel: Porcetaje de la ubicación horizontal desde el centro
 * tanto para el titulo como para el valor de las series.
 * {Number} paramCalculatedOffset: Diferencia de porcentaje de la ubicación horizontal
 * entre una serie y otra.
 * {Number} paramNumberOfElementsByLine Numero de series que se van a mostrar por cada fila.
 * @param {Array} datos: Datos especificos a pintar en el grafico.
 * @returns Devuelve el valor maximo del gauge y los datos.
 */
export function initGaugeYear(gaugeYearConfig, datos) {
  const misDatosArray = datos.resultset;
  const COLORS = [
    '#9c89b8',
    '#4ea8de',
    '#05668d',
    '#ffbf69',
    '#e56b6f',
    '#83c5be',
    '#02c39a',
    '#ee9b00',
    '#cdb4db',
    '#ffadad',
    '#ce4257',
    '#b7b7a4',
  ];

  if (datos.length === 0) {
    printNoDataChart(
      `#${gaugeYearConfig.idChart}`,
      `#${gaugeYearConfig.idNoData}`,
    );
  } else {
    printDataChart(
      `#${gaugeYearConfig.idNoData}`,
      `#${gaugeYearConfig.idChart}`,
    );
    const objColData = {
      type: 0,
      data: 1,
      time: 2,
    };
    const [maxValue, gaugeDataYears] = configureDataGaugeCommon(
      misDatosArray,
      objColData,
      COLORS.slice(),
      gaugeYearConfig.fontSize,
      gaugeYearConfig.paramOffsetCenterTitle,
      gaugeYearConfig.paramOffsetCenterDetail,
      gaugeYearConfig.paramOffsetLabel,
      gaugeYearConfig.paramCalculatedOffset,
      gaugeYearConfig.paramNumberOfElementsByLine,
    );
    const options = { ...defaultOptions };

    options.title.text = gaugeYearConfig.chartName;
    options.series.max = maxValue;
    options.series.data = gaugeDataYears;
    options.series.detail.fontSize = gaugeYearConfig.fontSize;
    options.series.detail.formatter = (value) =>
      addPointInteger(Math.round(value));
    options.series.axisTick.splitNumber = 5;
    options.color = COLORS.slice();
    options.series.axisLabel.formatter = (value) =>
      addPointInteger(Math.round(value));
    options.tooltip.formatter = (params) => formatRoundTooltip(params, false);
    initChart(gaugeYearConfig.idChart, options);
  }
}
